export const downloadFile = (url: string = '', fileName: string = '') => {
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;

  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  a.style.display = 'none';

  document.body.append(a);
  a.click();
  a.remove();
};
